import React, { Fragment, useState } from 'react';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { IconButton } from '@mui/material';
import CreateCategoryDialog from '../CreateCategoryDialog/CreateCategoryDialog';

const CreateCategoryButton = props => {
  const { team, ...rest } = props;
  const [isCreateCategoryDialogOpen, setIsCreateCategoryDialogOpen] = useState(false);

  const onClick = () => {
    setIsCreateCategoryDialogOpen(true);
  };

  const onCloseCreateCategoryDialog = () => {
    setIsCreateCategoryDialogOpen(false);
  };

  return (
    <Fragment>
      <CreateCategoryDialog team={team} open={isCreateCategoryDialogOpen} onClose={onCloseCreateCategoryDialog} />
      <IconButton onClick={onClick} {...rest} size="large">
        <PlaylistAddIcon />
      </IconButton>
    </Fragment>
  );
};

export default CreateCategoryButton;
